import React from 'react';
import { useLanguage } from '../../assets/js/LanguageContext';
import '../../assets/styles/Loader.css';

const Loader = ({ label, overlay = false, caption }) => {
  const { t } = useLanguage();

  const spinner = (
    <div className="tp-loader" role="status" aria-live="polite">
      <span className="tp-loader__text">{label || t('loader_text')}</span>
      <span className="tp-loader__ball" aria-hidden="true" />
    </div>
  );

  if (!overlay) return spinner;

  return (
    <div className={`tp-loader-overlay ${caption ? 'tp-loader-overlay--card' : ''}`.trim()}>
      {caption ? (
        <div className="tp-loader-overlay__box">
          {spinner}
          <p className="tp-loader-overlay__caption">{caption}</p>
        </div>
      ) : spinner}
    </div>
  );
};

export default Loader;
export { Loader };
